import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";

export const addEmail = createAsyncThunk("addEmails", async (d,{dispatch}) => {
  try {
    const res = await api.post(
      `${process.env.REACT_APP_BASE_URL}/notification/create`,
      {
        email: d.email,
        user_id: d.user_id,
      }
    );
    await dispatch(getEmail(d.user_id));
    return {};
  } catch (error) {
    throw error;
  }
});
export const getEmail = createAsyncThunk("getEmails", async (d) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/notification/filter/${d}`
    );
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});
export const deleteEmail = createAsyncThunk("deleteEmail", async (d,{dispatch}) => {
  // console.log(d)
  try {
    const res = await api.delete(
      `${process.env.REACT_APP_BASE_URL}/notification/delete/${d.id}`
    );    
     await  dispatch(getEmail(d.userId));
    return {} ;
  } catch (error) {
    throw error;
  }
});

const notificationSlice = createSlice({
  name: "schedule",
  initialState: {
    data: [],
    isLoading: false,
    isError: false,
    isSuccess:false,
    errMsg: "",
  },
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.errMsg = "";
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addEmail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addEmail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    });
    builder.addCase(addEmail.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
    builder.addCase(getEmail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getEmail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data =action.payload.data;
    });
    builder.addCase(getEmail.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
    builder.addCase(deleteEmail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteEmail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true
    });
    builder.addCase(deleteEmail.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
  },
});

export const notificationReducer = notificationSlice.reducer;
export const { reset } = notificationSlice.actions;